import { onLCP, onFID, onCLS } from 'web-vitals'

export const SG1Logs = (function () {
   var self = {}

   // Private
   var logs = {}

   const getBrowser = (item) => {
      if (window.performance) {
         var ua = navigator.userAgent
         var N = navigator.appName
         var tem
         var M = ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*([\d.]+)/i) || []
         M = M[2] ? [M[1], M[2]] : [N, navigator.appVersion, '-?']
         if (M && (tem = ua.match(/version\/([.\d]+)/i)) !== null) M[2] = tem[1]
         if (item === 'name') return M[0]
         if (item === 'version') return M[1].split('.')[0] // return major version
      }
   }

   const sendLogs = (logs) => {
      // ajout de timeTotal
      if (typeof window.dataStoreHP.webperf !== 'undefined') {
         logs.timeTotal = window.dataStoreHP.webperf.zgifTimeTotal
      }

      if (window.location.host === 'www.preprod.orange.fr') {
         var urlZgif = '//z.preprod.woopic.com/z.gif' // Demande des OPS pour des test zgif en preprod (à supprimer à terme)
      } else {
         var urlZgif = '//z.woopic.com/z.gif'
      }
      var xhr = new XMLHttpRequest()
      xhr.open('POST', urlZgif, true)
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      xhr.send(JSON.stringify(logs))
   }

   // Public
   self.init = () => {
      // log les erreur non catchées
      document.addEventListener('error', (event) => {
         if (/n1-tv|hp|n1-mobile|vitrine-boutique/.test(event.filename)) {
            SG1Logs.incLog('Err_RNDR')
         }
      })

      // Écoute du custom event "incLog"
      document.addEventListener('sg1_incLog', (event) => {
         const { key } = event.detail || {}
         if (key) {
            self.incLog(key)
         }
      })

      logs = {
         APP: 'HPONEI',
         page: '',
         isLogged: '',
         device: '',
         browserName: getBrowser('name'),
         browserVersion: getBrowser('version'),
         Err_FMTR: 0,
         Err_RNDR: 0,
         Err_PORCH: 0,
         Err_CORCH: 0,
         renderDuration: 0,
      }

      // @see https://web.dev/lcp/ (exprimée en ms... sous 2500, considéré comme bon)
      onLCP(({ value }) => {
         logs.LCP = Math.round(value)
      })
      // @see https://web.dev/fid/ (exprimée en ms... sous 100, considéré comme bon)
      onFID(({ value }) => {
         logs.FID = Math.round(value)
      })
      // @see https://web.dev/cls/ (sous 0.1, considéré comme bon)
      onCLS(
         ({ delta }) => {
            logs.CLS = Math.round(delta * 10000) / 10000
         },
         { reportAllChanges: true }
      )

      document.addEventListener('sseEndOfTransmition', (value) => {
         logs.SSEDuration = value.detail.responseTime
      })

      addEventListener('beforeunload', (event) => {
         const dataIsLogged = document?.body?.dataset?.islogged
         let isLogged = dataIsLogged !== undefined ? (dataIsLogged === 'true' ? 'logue' : 'non-logue') : 'isLogged-unknown'
         let pageId = document?.body?.id !== undefined ? document.body.id : 'pageId-unknown'
         logs.page = `${pageId}_${isLogged}`
         logs.isLogged = dataIsLogged !== undefined ? dataIsLogged === 'true' : ''
         logs.device = document?.body !== undefined ? (document.body.classList.contains('is-mobile') ? 'mobile' : 'desktop') : ''
         sendLogs(logs)
      })
   }

   self.incLog = (key) => {
      logs[key] += 1
   }

   return self
})()
